<template>
  <div class="parent">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    ...mapMutations(['clearuser']),
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  created () {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  watch: {
    '$route' (newval, oldval) {
      if (newval.params.func) {
        sessionStorage.setItem('func', newval.params.func)
      }
      if (oldval && newval.path === '/') {
        sessionStorage.clear()
        this.clearuser()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body .el-table th.gutter {
  display: table-cell !important;
}

body .el-table colgroup.gutter {
  display: table-cell !important;
}
</style>
<style>
body {
  font-family: "NotoSansSC-Regular"
}
.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  background-color: #90939c !important;
}
</style>
